var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M491.712 539.384L819.816 867.48c15.677 15.283 40.728 15.122 56.208-0.36 15.48-15.482 15.637-40.533 0.352-56.208l-299.8-299.816 299.816-299.808a40.002 40.002 0 1 0-56.568-56.576L491.712 482.816c-15.615 15.62-15.615 40.94 0 56.56v0.008z m-344 0L475.816 867.48c15.677 15.283 40.728 15.122 56.208-0.36 15.48-15.482 15.637-40.533 0.352-56.208l-299.8-299.816 299.816-299.808a40.002 40.002 0 1 0-56.568-56.576L147.712 482.816c-15.615 15.62-15.615 40.94 0 56.56v0.008z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/double-arrow-left.14d79b7aa35faeddd26a52b1ffa57a23.svg";
export { ForwardRef as ReactComponent };